import React from 'react'
import { GlobalStyles, useTheme } from '@mui/material'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const CustomToast: React.FC = () => {
  const theme = useTheme()

  return (
    <>
      <GlobalStyles
        styles={{
          '.Toastify__toast-container': {
            width: '360px',
            padding: 0,
            zIndex: 9999,
            [theme.breakpoints.down('sm')]: {
              width: '90vw',
              left: '50%',
              transform: 'translateX(-50%)',
              top: '12px',
              margin: 0
            }
          },
          '.Toastify__toast': {
            fontFamily: theme.typography.fontFamily,
            borderRadius: theme.appRadius.md,
            marginBottom: theme.spacing(1.5),
            [theme.breakpoints.down('sm')]: {
              borderRadius: theme.appRadius.lg,
              marginBottom: theme.spacing(1)
            }
          },
          '.Toastify__progress-bar': {}
        }}
      />

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme.palette.mode}
        limit={3}
      />
    </>
  )
}

export default CustomToast
